module.exports = __webpack_public_path__ + "img/somos_placa_rosa_en.317b9280.jpg";